import { AxiosInstance } from 'axios';
import { DashboardData, HttpResponse, Summary } from '@/interfaces';
import axiosClient from './axiosClientConfig';

class DashboardApplicationsService {
	constructor(private client: AxiosInstance) {}

	async getSummary(): Promise<HttpResponse<Summary>> {
		return this.client.get('/cases_clients/dashboard');
	}
	async getDashboardOverviewMetrics(): Promise<HttpResponse<DashboardData>> {
		return this.client.get('/analytics/case-metrics/lawyer-dashboard-overview');
	}
	async getClientAndCasesList(search: string): Promise<HttpResponse<any>> {
		return this.client.get(
			`/analytics/case-metrics/lawyer-dashboard-search/${search}`
		);
	}
}

export const dashboardApplicationsService = new DashboardApplicationsService(
	axiosClient
);
